<template>
    <div>
        <template v-if="value">
            <!-- <el-image class="curd-image" v-for="(item, index) in value.split(',')" :key="index" :src="item" fit="cover" :preview-src-list="[item]"></el-image> -->
            <!-- <video ref="videoPlayer" class="video-js"></video> -->

            <el-link type="primary" :underline="false" @click="videoShow=true">视频播放</el-link>
        </template>
        <el-dialog  :close-on-click-modal="false"  title="视频播放" :visible.sync="videoShow"
                   class="dialog-no-pd"  v-if="videoShow"
                   width="30%" :destroy-on-close="true" append-to-body :before-close='dialogClose'>
            <div >
                <video :src="value" :controls="true" :autoplay="true" class="curd-video"  ref="vueRef" ></video>
            </div>
        </el-dialog>
    </div>
</template>

<script>
export default {
    name: 'QuickAdminVideo',
    props: {
        value: {
            required: true,
            type: String | null,
        },
    },
    methods:{
        dialogClose(){
            this.$refs.vueRef.pause()
            console.log(1)
            this.videoShow=false
        }
    },
    data(){
        return{
            videoShow:false
        }
    }
}
</script>
<style>
.curd-video{
    width: 100%;
}
</style>
